{
  "testRamp": {
    "layout": "Diseño",
    "iterativeMode": "Modo iterativo",
    "showCurvedLines": "Mostrar líneas curvas",
    "showAircraftImages": "Mostrar imágenes de aeronave",
    "datasetSize": "Tamaño del dataset",
    "useSpaceQuality": "Usar optimización de calidad de espacio",
    "qualityMetric": "Métrica de calidad",
    "optimizationLevel": "Nivel de optimización",
    "safetyBufferMode": "Modo de margen de seguridad",
    "priorityFirstSorting": "Ordenar por prioridad",
    "showAreas": "Mostrar áreas",
    "showObstacles": "Mostrar obstáculos",
    "legends": {
      "obstacles": "Obstáculos",
      "noGoZones": "Zonas no-go"
    }
  }
}
